import {AnyIndex} from "../../types/common/index/AnyIndex";
import {ensure} from "../../types/guards/ensure";
import {isDefined} from "../../types/guards/isDefined";

export function asFakeRecord<T = unknown>(o?: unknown): Record<AnyIndex, T> {
    ensure(isDefined, o, 'Cannot cast to fake record - argument is undefined');
    return o as Record<AnyIndex, T>;
}
